import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AnalyticsInfo,
  AnalyticsResponse,
  DynamicQueryService,
  mapAnalyticsResponse,
  toISOString,
} from '@services/analytics-services/core';
import { OrderAnalyticsQuery, OrderStats } from '@services/analytics-services/orders/models';
import { OrderProductStats } from '@services/analytics-services/orders/models/order-product';
import { CachingApiService } from '@services/core-services/api-cache.service';

@Injectable({ providedIn: 'root' })
export class OrderAnalyticsService {
  constructor(
    private readonly queryService: DynamicQueryService,
    private readonly cacheApi: CachingApiService
  ) {}

  getAnalytics(context: OrderAnalyticsQuery): Observable<AnalyticsInfo<OrderStats>> {
    const { range, interval, compare, ...params } = context;
    return this.cacheApi
      .getWithCache<AnalyticsResponse<OrderStats>>('orders/metrics/stats', {
        ...params,
        date_from: toISOString(compare?.start || range.start),
        date_to: toISOString(range.end),
        interval,
      })
      .pipe(
        map(response => {
          return mapAnalyticsResponse<OrderStats>(response, context);
        })
      );
  }

  getTopSellingProducts(query: any): Observable<OrderProductStats[]> {
    return this.cacheApi
      .getWithCache<any>('orders/metrics/top-selling-products', {
        ...query,
        date_from: toISOString(query.date_from),
        date_to: toISOString(query.date_to),
      })
      .pipe(map(response => response.content.products as OrderProductStats[]));
  }
}
